import { render, staticRenderFns } from "./block-if-loading.vue?vue&type=template&id=1a139036&scoped=true"
import script from "./block-if-loading.vue?vue&type=script&lang=js"
export * from "./block-if-loading.vue?vue&type=script&lang=js"
import style0 from "./block-if-loading.vue?vue&type=style&index=0&id=1a139036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a139036",
  null
  
)

export default component.exports